export default function log(...args) {

  if (window.location.search.includes('debug')) {
    console.log('%cConsent: ', 'color: purple;', '-', ...args);
  }
};
